import Image1 from '../../assets/project1.jpg'
import Image2 from '../../assets/project2.jpg'
import Image3 from '../../assets/project3.jpg'
import Image4 from '../../assets/project4.jpg'
import Image5 from '../../assets/project5.jpg'
import Image6 from '../../assets/project6.jpg'
import Image7 from '../../assets/project7.jpg'
import Image8 from '../../assets/project8.jpg'
import Image9 from '../../assets/project9.jpg'

const data = [
    {
        id: 1,
        category: 'uiux',
        image: Image1,
        title: "Immerse Institute SEO (UIUX)",
        desc: "Helped team with SEO of the site",
        demo: 'https://imlanguages.com/',
        github: 'https://imlanguages.com/'
    },
    {
        id: 2,
        category: 'frontend',
        image: Image2,
        title: "Tindog Bootstrap (Frontend)",
        desc: "Used bootstrap 5 to create a new frontend for dogs to meet other dogs and hosted on github.",
        demo: 'https://ahsfar.github.io/tindog/',
        github: 'https://github.com/ahsfar/tindog'
    },
    {
        id: 3,
        category: 'frontend',
        image: Image3,
        title: "Github Finder (Frontend)",
        desc: "Used tailwind css and github api to find github users and their respective projects and hosted on vercel.",
        demo: 'https://api-github-user-finder-react.vercel.app/',
        github: 'https://github.com/egattor'
    },
    {
        id: 4,
        category: 'frontend',
        image: Image4,
        title: "Wordpress Portfolio (Frontend)",
        desc: "Created wordpress portfolio, bought domian and hosted on wordpress using siteground. Used divi theme builder for the wordpress theme.",
        demo: 'https://ahsanfarooq.com/',
        github: 'https://ahsanfarooq.com/'
    },
    {
        id: 5,
        category: 'frontend',
        image: Image5,
        title: "React Portfolio (Frontend)",
        desc: "Created react portfolio from scratch, created sections, used context api, useState and useRef hooks, bought domian and hosted on hostinger.",
        demo: 'https://ahsanfarooq.net/',
        github: 'https://github.com/ahsfar/react-portfolio'
    },
    {
        id: 6,
        category: 'backend',
        image: Image6,
        title: "Proshop - continous (FullStack)",
        desc: "Creating full-stack ecommerce website using MERN stack.",
        demo: 'https://github.com/ahsfar/proshop',
        github: 'https://github.com/ahsfar/proshop'
    }

]


export default data